import { defineComponent as _defineComponent } from 'vue'
import { FeatureFlags } from '@busy-human/vue-component-library';
import { RouterLink } from 'vue-router';
import { firestore } from '@/util/firebase';
import { doc, collection, getDoc } from 'firebase/firestore';


const SYNC_QUEUE_PATH = "sync-queue";
const SYNC_QUEUE_ID = "queue";


export default /*#__PURE__*/_defineComponent({
  __name: 'admin-nav',
  setup(__props, { expose: __expose }) {
  __expose();

async function connectToSyncQueue() {
	const col = collection(firestore, SYNC_QUEUE_PATH);
	const docRef = doc(col, SYNC_QUEUE_ID);

	const snap = await getDoc(docRef);

}




const __returned__ = { SYNC_QUEUE_PATH, SYNC_QUEUE_ID, connectToSyncQueue, get FeatureFlags() { return FeatureFlags }, get RouterLink() { return RouterLink }, get firestore() { return firestore }, get doc() { return doc }, get collection() { return collection }, get getDoc() { return getDoc } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})